document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.mmb-mega--shop').forEach(function (mega) {
    const items = mega.querySelectorAll('.mmb-shop__cat-item');
    const panels = mega.querySelectorAll('.mmb-shop__sub-panel');

    if (!items.length || !panels.length) return;

    let clearTimer;

    const details = mega.closest('details');
    const disclosure = mega.closest('.header__menu-disclosure');
    const hoverScope = details || disclosure || mega;

    function clearActive() {
      items.forEach(function (item) {
        item.classList.remove('is-active');
      });

      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
      });
    }

    function activate(target) {
      clearTimeout(clearTimer);
      clearActive();

      items.forEach(function (item) {
        if (item.dataset.cat === target) {
          item.classList.add('is-active');
        }
      });

      panels.forEach(function (panel) {
        if (panel.id === 'mmb-panel-' + target) {
          panel.classList.add('is-active');
        }
      });
    }

    clearActive();

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        activate(item.dataset.cat);
      });

      item.addEventListener('focusin', function () {
        activate(item.dataset.cat);
      });
    });

    hoverScope.addEventListener('mouseenter', function () {
      clearTimeout(clearTimer);
    });

    hoverScope.addEventListener('mouseleave', function () {
      clearTimer = setTimeout(function () {
        clearActive();
      }, 120);
    });

    if (details) {
      details.addEventListener('toggle', function () {
        clearTimeout(clearTimer);
        clearActive();
      });
    }
  });
});